import { render, staticRenderFns } from "./SurferHome.vue?vue&type=template&id=2fd8fd18"
import script from "./SurferHome.vue?vue&type=script&lang=js"
export * from "./SurferHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports